
import React, { useEffect } from "react";
import { useSelector } from 'react-redux';
import { useParams, useNavigate } from "react-router-dom";
import NavBar from "../../componenets/navbar/NavBar";
import AddonsList from "../../componenets/addons/AddonsList";

const Addons = () =>{
    const role = useSelector((state) => state.user.userDetails.UserRole);
    const navigate = useNavigate();
    const { type } = useParams();
    const addList = ['priority', 'lead-source', 'lead-status', 'photoshoot-type', 'photographer', 'telecaller'];
    useEffect(() => {
        if (!addList.includes(type)) {
            navigate('/404'); // Redirect to the 404 page
        }
    }, [type, navigate]);
    
    // user check
    useEffect(()=>{
        if(role && role !== "Super Admin"){
            navigate("/"); 
        }
    },[role, navigate]);
    
    const navActive = useSelector((state) => state.navActive.value);
    useEffect(() => {
        const bodypd = document.getElementById('cbody');
        (navActive) ?  bodypd.classList.add('body-pd') : bodypd.classList.remove('body-pd');
    }, [navActive]);

    return(<>
        <NavBar />
        <div id="cbody" className="cbody">
            <div className="concard">
                <AddonsList type={type}/>
            </div>
        </div>
    </>);
};

export default Addons;